import { actionType } from "../actions/ineReportsActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = {};
const innkrevingReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default innkrevingReducer;
